import type { PlannedRouteDto } from "../types/api/planRoute/routePlanning.types";
import type { Route } from "../pages/MapMonitoring/types";
import { RouteService } from "../pages/MapMonitoring/services/routeService";

export function extractPlannedRoutesFromApiPayload(raw: unknown): PlannedRouteDto[] {
    if (raw == null) return [];
    if (Array.isArray(raw)) return raw as PlannedRouteDto[];
    if (typeof raw !== "object") return [];
    const o = raw as Record<string, unknown>;
    for (const key of ["items", "data", "routes", "Routes", "value", "Value"] as const) {
        const v = o[key];
        if (Array.isArray(v)) return v as PlannedRouteDto[];
    }
    return [];
}

function sortedCoordsFromPoints(dto: PlannedRouteDto): [number, number][] {
    const pts = [...dto.points].map((p, i) => ({ ...p, order: p.order ?? i }));
    pts.sort((a, b) => a.order - b.order);
    return pts.map((p) => [p.latitude, p.longitude]);
}

function sortedRoutePoints(dto: PlannedRouteDto) {
    const pts = [...dto.points].map((p, i) => ({ ...p, order: p.order ?? i }));
    pts.sort((a, b) => a.order - b.order);
    return pts.map((p, i) => ({
        coords: [p.latitude, p.longitude] as [number, number],
        order: p.order ?? i,
        id: p.containerPlatformId != null ? String(p.containerPlatformId) : undefined,
        name: p.name ?? undefined,
        // Для planned-маршрутов всегда задаем completed (если с бэка не пришел — считаем null).
        completed: p.completed ?? null,
    }));
}

export function plannedDtosToMapRoutes(
    dtos: PlannedRouteDto[],
    fallbackAlgorithm?: string | null
): Route[] {
    const out: Route[] = [];
    for (let i = 0; i < dtos.length; i++) {
        const dto = dtos[i];
        const coords = sortedCoordsFromPoints(dto);
        if (coords.length < 2) continue;

        const style =
            dto.lineColorHex && /^#[0-9A-Fa-f]{6}$/.test(dto.lineColorHex)
                ? { ...RouteService.getDefaultStyle(), strokeColor: dto.lineColorHex }
                : RouteService.getStyleByIndex(i);

        const routePoints = sortedRoutePoints(dto);
        const base = RouteService.createRoute(
            dto.id,
            dto.name || `Маршрут ${i + 1}`,
            routePoints,
            style
        );
        out.push({
            ...base,
            transportId: String(dto.transportId),
            plannedMeta: {
                routeDate: dto.routeDate,
                algorithm: dto.algorithm ?? fallbackAlgorithm ?? undefined,
            },
        });
    }
    return out;
}
